const getItemId = (id, index) => `${id}-item-${index}`;
const getSubItemId = (id, index) => `${id}-sub-item-${index}`;
const createAccessbilityProps = ({
  id,
  highlightedIndex,
  highlightedSubIndex,
  isOpen,
  hasSubItems
}) => {
  const menuId = `${id}-menu`;
  const assistiveDescriptionId = `${id}-aria-description`;
  return {
    inputProps: {
      id,
      role: "combobox",
      "aria-haspopup": "listbox",
      "aria-owns": isOpen ? menuId : void 0,
      // backwards compatibility for screenreaders implementing ARIA 1.0
      "aria-controls": menuId,
      "aria-expanded": isOpen,
      "aria-autocomplete": "list",
      "aria-activedescendant": typeof highlightedIndex === "number" ? hasSubItems ? getSubItemId(id, highlightedSubIndex) : getItemId(id, highlightedIndex) : void 0,
      "aria-describedby": assistiveDescriptionId,
      autoComplete: "off",
      // https://stackoverflow.com/questions/47775041/disable-autofill-in-chrome-63/47822599
      spellCheck: false
    },
    assistiveDescriptionProps: {
      id: assistiveDescriptionId
    },
    menuProps: {
      id: menuId,
      role: "listbox",
      "aria-live": "polite"
    },
    getItemProps: ({
      index,
      label,
      description,
      groupHeading
    }) => ({
      id: hasSubItems ? getSubItemId(id, index) : getItemId(id, index),
      role: "option",
      "aria-selected": hasSubItems ? index === highlightedSubIndex : index === highlightedIndex,
      "aria-label": `${label}${description ? ` - ${description}` : ""}${groupHeading ? ` (${groupHeading})` : ""}`
    })
  };
};
export {
  createAccessbilityProps,
  getItemId,
  getSubItemId
};
